



























































import {Component, Emit, Inject, Prop, Watch} from "vue-property-decorator";
import CommonBase from "../CommonBase";
import Api from "./Api";
import {Company, PendingPerson, Person, TerminalLocation, Role} from "../../modules/models";
import BaseApi from "../../store/modules/base";
import rd from "@/modules/vRoutedefs";

export class RoleAddData {
    constructor(public orgNum: number, public personGuid: string, public roleid: number, public locid: number | null) {}
}

@Component
export default class RoleAdd extends CommonBase {
    @Inject()
    api!: Api;

    @Inject()
    baseApi!: BaseApi;

    @Prop({default: null})
    person!: Person | PendingPerson | null;
    @Prop({default: false})
    value!: boolean;

    roledescription(id: number): string {
        return Role.descriptions[id];
    }

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.$emit("input", v);
    }

    loadingAvailableCompanies = false;
    availableCompanies: Company[] = [];
    addCompany: Company | null = null;
    availableCompaniesError: string[] = [];

    roletype = 0;
    roleid = 0;

    loadingAvailableLocations = false;
    availableLocations: TerminalLocation[] = [];
    addLocation: TerminalLocation | null = null;
    availableLocationsError: string[] = [];

    get userManualTo() {
        return {path: rd.docs.roleinfo.path};
    }

    async loadAvailableCompanies() {
        this.loadingAvailableCompanies = true;
        this.availableLocations = [];
        try {
            this.availableCompanies = await this.api.fetchGrantableCompanies();
            if(this.availableCompanies.length == 1) {
                this.addCompany = this.availableCompanies[0];
            } else if(this.availableCompanies.length == 0) {
                this.availableCompaniesError = ["Ingen firma tilgjengelig"];
            } else {
                this.availableCompaniesError = ["Velg firma først"];
            }
        } catch (err) {
            this.emitError(err);
        }
        this.loadingAvailableCompanies = false;
    }
    validateCompanySelect(): boolean | string {
        this.availableCompaniesError = [];
        return this.addCompany != null ? true : "Firma valg er påkrevd";
    }

    @Watch("value")
    onValueChanged() {
        if(this.value && this.availableCompanies.length == 0) {
            this.loadAvailableCompanies();
        }
    }

    @Watch("addCompany")
    onAddCompanyChanged() {
        if(this.roletype === 2) {
            this.loadAvailableLocations();
        }
    }
    @Watch("roletype")
    onRoletypeChanged(newRoletype: number) {
        if(newRoletype == 2) {
            this.loadAvailableLocations();
        } else {
            this.addLocation = null;
        }
        this.roleid = 0;
    }

    async loadAvailableLocations() {
        this.loadingAvailableLocations = true;
        try {
            if(this.addCompany != null) {
                this.availableLocations = await this.api.fetchGrantableLocations(this.addCompany.orgNum);
            } else {
                this.availableLocations = [];
            }
            if(this.availableLocations.length == 1) {
                this.addLocation = this.availableLocations[0];
            } else if(this.availableLocations.length == 0) {
                this.availableLocationsError = ["Ingen anlegg tilgjengelig"];
            } else {
                this.availableLocationsError = ["Velg anlegg"];
            }
        } catch (err) {
            this.emitError(err);
        }
        this.loadingAvailableLocations = false;
    }
    validateLocationSelect(): boolean | string {
        this.availableLocationsError = [];
        return this.addLocation != null ? true: "Valg av anlegg nødvendig";
    }

    close() {
        this.opened = false;
    }

    get addEnabled() {
        return this.addCompany != null && this.roleid > 0 &&
            (this.roletype === 1 || (this.roletype === 2 && this.addLocation != null));
    }

    add() {
        if(this.addCompany != null && this.roleid > 0 && this.person != null && this.person.guid != null) {
            const locid = this.addLocation != null ? this.addLocation.id : null;
            const data = new RoleAddData(this.addCompany.orgNum, this.person.guid, this.roleid, locid);
            this.$emit("at-user-role-add", data);
            this.roletype = 0;
            this.roleid = 0;
            this.addLocation = null;
            this.close();
        }
    }
}
